import React, { useState } from "react";

interface SliderProps {
  min: number;
  max: number;
  step?: number;
  value?: number;
  onChange?: (value: number) => void;
}

export default function Slider({
  min,
  max,
  step = 1,
  value,
  onChange
}: SliderProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value);
    onChange?.(newValue);
  };

  return (
    <div className="w-full">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        className="w-full h-1 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-cornflower-blue-500"
      />

      <div className="flex justify-between text-sm text-gray-500 mt-1">
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  );
}
